import React from 'react';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import { BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/updateServicesConfirmationDialogStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IUpdateServicesConfirmationDialog {
	isOpen: boolean;
	hideDialog: () => void;
}

const UpdateServicesConfirmationDialog = ({ isOpen, hideDialog }: IUpdateServicesConfirmationDialog) => {
	const classes = useStyles();

	return (
		<CustomConfirmationDialog isOpen={isOpen} hideDialog={hideDialog} withoutIcon width={400}>
			<div className={classes.textWrapper}>
				<BodyM color="primary-light" disableMargin>
					{translate('refresh.statuses.info')}
				</BodyM>
			</div>
		</CustomConfirmationDialog>
	);
};

export default UpdateServicesConfirmationDialog;
